import { useEffect, useState, useRef, useCallback } from 'react';
import { BottomTabBar } from './PhoneHeader';
import TabContent from './TabContent';
import Onboarding from './Onboarding';

const Splash = () => {
  const [activeTab, setActiveTab] = useState('feed');
  const contentRef = useRef(null);
  const [showOnboarding, setShowOnboarding] = useState(true);
  const [isAddingClip, setIsAddingClip] = useState(false);
  const [isClipDetailOpen, setIsClipDetailOpen] = useState(false);

  // Keep viewport neutral for the monochrome splash experience
  useEffect(() => {
    const el = document.documentElement;
    const body = document.body;
    el.classList.remove('app-viewport-green');
    body.classList.remove('app-viewport-green');
  }, []);

  const handleCompleteOnboarding = useCallback(() => {
    setShowOnboarding(false);
  }, []);

  // Ensure scroll resets to top on tab/profile state changes
  const scrollToTop = useCallback(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = 0;
    }
  }, []);

  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab);
    scrollToTop();
  }, [scrollToTop]);

  const handleAddClick = useCallback(() => {
    setActiveTab('clipboard');
    setIsAddingClip(true);
  }, []);

  const tabBackground = '#efece4';

  return (
    <div
      className="fixed inset-0 overflow-hidden editorial-paper text-black"
    >
      {/* Scrollable Content Area */}
      <div
        ref={contentRef}
        className={`absolute inset-0 overflow-y-auto overflow-x-hidden [&::-webkit-scrollbar]:hidden pb-16 ${isClipDetailOpen ? 'z-40' : 'z-10'}`}
        style={{
          WebkitOverflowScrolling: 'touch',
          scrollbarWidth: 'none',
          paddingTop: 'env(safe-area-inset-top, 0px)',
          backgroundColor: tabBackground,
          pointerEvents: showOnboarding ? 'none' : 'auto',
        }}
        aria-hidden={showOnboarding ? 'true' : 'false'}
      >
        <TabContent 
          activeTab={activeTab}
          isAddingClip={isAddingClip}
          setIsAddingClip={setIsAddingClip}
          onClipDetailOpenChange={setIsClipDetailOpen}
        />
      </div>

      {/* Bottom Navigation Bar */}
      <div
        className="absolute bottom-0 left-0 right-0 z-30"
        style={{
          paddingBottom: 'env(safe-area-inset-bottom, 0px)',
          backgroundColor: tabBackground,
          pointerEvents: showOnboarding ? 'none' : 'auto',
        }}
      >
        <BottomTabBar
          activeTab={activeTab}
          setActiveTab={handleTabChange}
          onAddClick={handleAddClick}
        />
      </div>

      {showOnboarding && (
        <Onboarding onComplete={handleCompleteOnboarding} />)
      }
    </div>
  );
};

// Splash has no props, so no PropTypes needed

export default Splash;
